<template>
  <div class="community-agents-page">
    <div class="filter-bar">
      <div class="search-box">
        <input
          type="text"
          v-model="searchKey"
          placeholder="搜索账号(用户ID)..."
          class="search-input"
        />
        <button @click="search" class="search-btn">搜索</button>
      </div>
      <button @click="openAddModal" class="add-btn">+ 添加小区代理</button>
    </div>

    <div class="table-container">
      <table class="community-agents-table">
        <thead>
          <tr>
            <th>代理ID</th>
            <th>用户ID</th>
            <th>开始日期</th>
            <th>结束日期</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="agent in agents" :key="agent.id">
            <td>{{ agent.id }}</td>
            <td>{{ agent.userId || agent.user_id }}</td>
            <td>{{ formatDate(agent.startDate || agent.start_date) }}</td>
            <td>{{ formatDate(agent.endDate || agent.end_date) }}</td>
            <td><span :class="'status status-' + (agent.status === 1 ? 1 : 0)">{{ agent.status === 1 ? '启用' : '禁用' }}</span></td>
            <td>{{ (agent.created_at || agent.createdAt || '').substring(0, 10) }}</td>
            <td>
              <button @click="viewCommunities(agent)" class="action-btn communities">关联小区</button>
              <button @click="editAgent(agent)" class="action-btn edit">编辑</button>
              <button @click="toggleStatus(agent)" class="action-btn" :class="agent.status === 1 ? 'disable' : 'enable'">
                {{ agent.status === 1 ? '禁用' : '启用' }}
              </button>
              <button @click="deleteAgent(agent)" class="action-btn delete">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1" @click="currentPage--; loadList()" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
      <button :disabled="currentPage === totalPages" @click="currentPage++; loadList()" class="page-btn">下一页</button>
    </div>

    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingAgent ? '编辑小区代理' : '添加小区代理' }}</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>用户ID</label>
            <input v-model="form.userId" type="number" class="form-control" placeholder="请输入关联的用户ID" />
          </div>
          <div class="form-group">
            <label>开始日期</label>
            <input v-model="form.startDate" type="date" class="form-control" />
          </div>
          <div class="form-group">
            <label>结束日期（留空表示长期）</label>
            <input v-model="form.endDate" type="date" class="form-control" />
          </div>
          <div class="form-group">
            <label>状态</label>
            <select v-model.number="form.status" class="form-control">
              <option :value="1">启用</option>
              <option :value="0">禁用</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">取消</button>
          <button @click="saveAgent" class="btn-save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCommunityAgentList,
  createCommunityAgent,
  updateCommunityAgent,
  deleteCommunityAgent
} from '@/api/communityAgents'

export default {
  name: 'CommunityAgents',
  data() {
    return {
      searchKey: '',
      currentPage: 1,
      totalPages: 1,
      agents: [],
      showModal: false,
      editingAgent: null,
      form: {
        userId: '',
        startDate: '',
        endDate: '',
        status: 1
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    formatDate(value) {
      if (!value) return '长期'
      return String(value).substring(0, 10)
    },
    async loadList() {
      try {
        const params = { page: this.currentPage, pageSize: 20 }
        if (this.searchKey.trim()) {
          params.keyword = this.searchKey.trim()
        }
        const response = await getCommunityAgentList(params)
        if (response.code === 0) {
          this.agents = response.data.list || []
          this.totalPages = response.data.pageSize
            ? Math.ceil(response.data.total / response.data.pageSize)
            : 1
        }
      } catch (error) {
      }
    },
    search() {
      this.currentPage = 1
      this.loadList()
    },
    openAddModal() {
      this.editingAgent = null
      this.form = { userId: '', startDate: '', endDate: '', status: 1 }
      this.showModal = true
    },
    editAgent(agent) {
      this.editingAgent = agent
      this.form = {
        userId: agent.userId || agent.user_id || '',
        startDate: (agent.startDate || agent.start_date || '').substring(0, 10),
        endDate: (agent.endDate || agent.end_date || '').substring(0, 10),
        status: agent.status === 1 ? 1 : 0
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.editingAgent = null
      this.form = { userId: '', startDate: '', endDate: '', status: 1 }
    },
    async saveAgent() {
      if (!this.form.userId) {
        alert('请输入用户ID')
        return
      }
      const payload = {
        userId: Number(this.form.userId),
        startDate: this.form.startDate || null,
        endDate: this.form.endDate || null,
        status: this.form.status
      }
      try {
        const response = this.editingAgent
          ? await updateCommunityAgent(this.editingAgent.id, payload)
          : await createCommunityAgent(payload)
        if (response && response.code === 0) {
          alert(this.editingAgent ? '更新成功' : '添加成功')
          this.loadList()
          this.closeModal()
        } else {
          alert(response?.message || '操作失败')
        }
      } catch (error) {
        alert('保存失败，请稍后重试')
      }
    },
    toggleStatus(agent) {
      const action = agent.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}小区代理（ID: ${agent.id}）吗？`)) {
        agent.status = agent.status === 1 ? 0 : 1
      }
    },
    async deleteAgent(agent) {
      if (!confirm(`确定要删除小区代理（ID: ${agent.id}）吗？`)) return
      try {
        const response = await deleteCommunityAgent(agent.id)
        if (response && response.code === 0) {
          alert('删除成功')
          this.loadList()
        } else {
          alert(response?.message || '删除失败')
        }
      } catch (error) {
        alert('删除失败，请稍后重试')
      }
    },
    async viewCommunities(agent) {
      this.$router.push({ path: '/community-agents/communities', query: { community_agent_id: agent.id } })
    }
  }
}
</script>

<style scoped>
.community-agents-page {
  padding: 20px;
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.search-box {
  display: flex;
  gap: 10px;
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  width: 250px;
}

.search-btn {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.add-btn {
  padding: 10px 20px;
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.community-agents-table,
.community-rel-table {
  width: 100%;
  border-collapse: collapse;
}

.community-agents-table th,
.community-agents-table td,
.community-rel-table th,
.community-rel-table td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.community-agents-table th,
.community-rel-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.status {
  border-radius: 20px;
  font-size: 12px;
  padding: 4px 12px;
}

.status-1 { background: #e8f5e9; color: #2ecc71; }
.status-0 { background: #ffebee; color: #e74c3c; }

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
}

.action-btn.communities { background: #9b59b6; color: #fff; }
.action-btn.edit { background: #3498db; color: #fff; }
.action-btn.disable { background: #e74c3c; color: #fff; }
.action-btn.enable { background: #2ecc71; color: #fff; }
.action-btn.delete { background: #95a5a6; color: #fff; }

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 480px;
  max-width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-btn {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.empty-tip {
  text-align: center;
  color: #999;
  padding: 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.btn-save {
  padding: 8px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
